import { render } from "./PeopleList.vue?vue&type=template&id=b56de58e&scoped=true"
import script from "./PeopleList.vue?vue&type=script&lang=js"
export * from "./PeopleList.vue?vue&type=script&lang=js"

import "./PeopleList.vue?vue&type=style&index=0&id=b56de58e&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b56de58e"]])

export default __exports__